import { render, staticRenderFns } from "./GroupPackageLayout.vue?vue&type=template&id=90a839f8"
import script from "./GroupPackageLayout.vue?vue&type=script&lang=js"
export * from "./GroupPackageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports